/*
 * Atribuirea variantei A/B și stampilarea ei în URL.
 *
 * Redirectul propriu-zis rulează inline în <head> (vezi layout/theme.liquid),
 * pentru că trebuie să se execute înainte de primul paint. Fișierul acesta se
 * ocupă de partea care poate aștepta: marcarea variantei în URL, ca formularul
 * de comandă să o trimită mai departe pe comandă, și expunerea ei către dataLayer.
 *
 * De ce utm_term: Meta Ads nu îl populează automat, deci nu intră în conflict
 * cu atribuirea la nivel de reclamă din utm_source/medium/campaign/content.
 */
(function () {
  'use strict';

  var configEl = document.getElementById('zv-tracking-config');
  if (!configEl) return;

  var cfg;
  try {
    cfg = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  if (!cfg.isProduct) return;

  var utmParam = cfg.utmParam || 'utm_term';
  var variantName = cfg.variantName || 'lp-direct';
  var params = new URLSearchParams(window.location.search);

  // Marcăm varianta fără să distrugem atribuirea campaniei.
  //
  // Dacă parametrul lipsește, îl setăm. Dacă reclama a trimis deja o valoare,
  // NU o suprascriem: o extindem cu sufixul variantei. Altfel, orice campanie
  // care folosește utm_term ar face testul A/B imposibil de citit: comanda ar
  // ajunge în Shopify fără să spună de pe care pagină a venit.
  var existing = params.get(utmParam);
  var desired = existing ? existing + '__' + variantName : variantName;

  if (!existing || existing.indexOf(variantName) === -1) {
    params.set(utmParam, desired);
    var qs = params.toString();
    var newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    try {
      window.history.replaceState(window.history.state, '', newUrl);
    } catch (e) {
      /* replaceState poate eșua în contexte restrânse; nu e critic */
    }
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'zv_variant_view',
    page_variant: variantName,
    page_variant_label: cfg.variant
  });

  // Expus pentru depanare din consolă.
  window.ZV_AB = window.ZV_AB || {};
  window.ZV_AB.name = variantName;
  window.ZV_AB.utmParam = utmParam;
})();
